module.exports = __webpack_public_path__ + "static/media/presenterlogo.9446f877.png";